<template>
  <div class="c-icon">
    <Upload action="" :disabled="disabled" :before-upload="preUpload">
      <Spin size="large" fix v-if="loading"></Spin>
      <div class="m-wrapper">
        <Icon type="md-add" size="48" color="#f8f8f8"></Icon>
      </div>
      <div class="m-view-box" v-if="icon">
        <img :src="icon" alt="" />
      </div>
    </Upload>
    <!-- 提示尺寸 -->
    <div class="m-file-size">
      <span>头像图片规格：{{ width }}x{{ height }}</span>
      <span>头像图片大小：{{ size | smartSize }}</span>
      <span>支持类型：{{ format | formatType }}</span>
    </div>
  </div>
</template>
<script>
import mixins from './mixins'
import { isArray } from '@/common/js/utils'
import { uploadLocalImage } from '@/api/baidu.model'
export default {
  name: 'cIcon',
  mixins: [mixins],
  props: {
    value: {
      type: [String, Number]
    },
    name: {
      type: String
    },
    width: {
      type: Number
    },
    height: {
      type: Number
    },
    size: {
      type: Number
    },
    disabled: {
      type: Boolean,
      default() {
        return false
      }
    },
    format: {
      type: Array,
      default() {
        return ['jpeg', 'png']
      }
    }
  },
  computed: {
    icon: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    uploadFile(file) {
      const params = {
        account: this.$store.state.Baidu.account,
        width: this.width,
        height: this.height,
        file
      }

      this.loading = true
      uploadLocalImage(params).then((data) => {
        this.loading = false
        data = isArray(data) && data.pop()
        if (data) this.$emit('on-upload', { name: this.name, size: this.size, data })
      })
    }
  },
  data() {
    return {
      loading: false
    }
  },
  watch: {
    value(nVal) {
      this.$emit('on-change', nVal)
    }
  }
}
</script>
<style lang='scss' scoped>
.c-icon {
  position: relative;
  z-index: 998;
  width: inherit;
  height: inherit;

  .m-wrapper {
    border-radius: 4px;
    border: solid 1px #efefef;
    width: 80px;
    height: 80px;
    background-color: #e8e8e8;

    .ivu-icon {
      margin-left: 50%;
      margin-top: 50%;
      transform: translate3d(-50%, -50%, 0);
    }

    ::v-deep .ivu-upload-list {
      display: none;
    }
  }

  .m-view-box {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 990;

    img {
      width: 80px;
      height: 80px;
    }
  }

  .m-file-size {
    // opacity 0
    width: 500px;
    position: absolute;
    z-index: 992;
    top: 0;
    left: 100px;
    color: #787878;

    span {
      display: block;
      line-height: 18px;
    }
  }

  .c-col-msg {
    position: absolute;
    z-index: 997;
    left: 0;
    bottom: -16px;
    color: #ff4400;
  }
}
</style>
